"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const client_1 = require("@apollo/client");
const react_stripe_js_1 = require("@stripe/react-stripe-js");
const stripe_js_1 = require("@stripe/stripe-js");
const AccountContext_1 = require("contexts/AccountContext");
const useCustomSearchParams_1 = require("hooks/useCustomSearchParams");
const react_router_dom_1 = require("react-router-dom");
const graphql_1 = require("./graphql");
const config_1 = require("assets/styles/config");
const PaymentMethodForm_1 = __importDefault(require("./PaymentMethodForm"));
const EmptyState_1 = __importDefault(require("./EmptyState"));
const stripePromise = (0, stripe_js_1.loadStripe)(env.STRIPE_PUB_KEY);
const PaymentMethod = () => {
    var _a;
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [search] = (0, useCustomSearchParams_1.useCustomSearchParams)();
    if (search.redirect_status === 'succeeded') {
        navigate('/orders', { replace: true });
    }
    const { account } = (0, AccountContext_1.useAccount)();
    const [createSetupIntent, { data, error }] = (0, client_1.useMutation)(graphql_1.CREATE_SETUP_INTENT);
    (0, react_1.useEffect)(() => {
        if (account) {
            // Once we have the `account` we call the mutation to create a SetupIntent
            createSetupIntent({
                variables: { input: { accountId: account === null || account === void 0 ? void 0 : account.id } }
            });
        }
    }, [account]);
    const setupIntent = (_a = data === null || data === void 0 ? void 0 : data.createSetupIntent) === null || _a === void 0 ? void 0 : _a.setupIntent;
    if (error) {
        navigate('/orders', { replace: true });
    }
    if (setupIntent === null || setupIntent === void 0 ? void 0 : setupIntent.clientSecret) {
        const options = {
            appearance: {
                variables: {
                    fontFamily: config_1.fontFamilies.primary,
                    fontSizeBase: '16.25px'
                }
            },
            // passing the client secret obtained from the server
            clientSecret: setupIntent === null || setupIntent === void 0 ? void 0 : setupIntent.clientSecret
        };
        return (react_1.default.createElement(react_stripe_js_1.Elements, { options: options, stripe: stripePromise },
            react_1.default.createElement(PaymentMethodForm_1.default, null)));
    }
    // render Skeleton Form while we're initializing Stripe
    return react_1.default.createElement(EmptyState_1.default, null);
};
exports.default = PaymentMethod;
